import apiClient from "@/axiosConfig";

class SystemService {
  static async getReleaseInfo() {
    return await apiClient.get("/system/release");
  }

  static async getCapabilities() {
    return await apiClient.get("/system/capabilities");
  }
}

export default SystemService;
